import { MijnRoute } from '../../mijn-navigatie.model';

export const PLANNED_PAYMENT_VIEW: MijnRoute = {
    path: 'ingeplande-overboeking/:id',
    navigationEvent: 'toIngeplandeOverboeking',
    regex: /^\/ingeplande-overboeking\/[^/]+$/,
    webcomponent: 'mijn-transacties-ingepland-webcomponent'
};
